export default __webpack_public_path__ + "static/media/DSC05897.f1254200.jpg";